import React from 'react';
import { motion } from 'framer-motion';
import { ClosingLine, InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { snakifyUseCases } from '../../data/snakkerStory';
export function SlideSnakify({}: SlideProps) {
  return <InteriorSlide surface data-id="element-564" data-mp="186uh1jaqgygw">
      <SlideTitle eyebrow="What could we Snakify?" data-id="element-565" data-mp="18749ddj93hpr">
        Not every message needs a Snak. <span className="text-[var(--brand)]" data-id="element-566" data-mp="1d67cutjl1fvm">Important ones might.</span>
      </SlideTitle>

      <ul className="mt-[clamp(1.25rem,2.5vw,2.25rem)] grid min-h-0 flex-1 grid-cols-2 gap-[clamp(0.5rem,0.9vw,0.85rem)] md:grid-cols-5 md:grid-rows-2" data-id="element-567" data-mp="1i4s4w5ookt8z">
        {snakifyUseCases.map((uc, i) => <motion.li key={uc.label} initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.12 + i * 0.05,
        duration: 0.4
      }} className={`flex min-h-0 flex-col justify-between rounded-2xl p-[clamp(0.9rem,1.6vw,1.4rem)] ${uc.played ? 'bg-[var(--brand)] text-white' : 'bg-white ring-1 ring-[var(--fg)]/[0.06]'}`} data-id="element-568" data-mp="1r5gkv5xmx3oi" data-mpi={i}>
            <span className={`font-mono text-[clamp(0.6rem,0.78vw,0.72rem)] tracking-[0.2em] ${uc.played ? 'text-white/70' : 'text-[var(--muted)]'}`} data-id="element-569" data-mp="30z728h6xefsm">
              {String(i + 1).padStart(2, '0')}
            </span>
            <div data-id="element-570" data-mp="2r3m62zojg9qs">
              <h3 className={`text-[clamp(1rem,1.65vw,1.55rem)] font-extrabold leading-[1.08] tracking-[-0.03em] ${uc.played ? 'text-white' : 'text-[var(--fg)]'}`} data-id="element-571" data-mp="2qzyazw3g3f9y">
                {uc.label}
              </h3>
              <p className={`mt-1.5 text-[clamp(0.7rem,0.92vw,0.88rem)] font-medium leading-snug ${uc.played ? 'text-[var(--brand-lighter)]' : 'text-[var(--muted)]'}`} data-id="element-572" data-mp="3epivijf8yklc">
                {uc.hint}
              </p>
            </div>
          </motion.li>)}
      </ul>

      <ClosingLine delay={0.75} data-id="element-573" data-mp="1yc2h0z59g1gv">
        Start with the message that matters. <span className="text-[var(--brand)]" data-id="element-574" data-mp="qdy40zrj0f4s">Then design the interaction around it.</span>
      </ClosingLine>
    </InteriorSlide>;
}